/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reference_Field_Net_DaysInputs */

const en_reference_field_net_days = /** @type {(inputs: Reference_Field_Net_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Net days`)
};

/**
* | output |
* | --- |
* | "Net days" |
*
* @param {Reference_Field_Net_DaysInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const reference_field_net_days = /** @type {((inputs?: Reference_Field_Net_DaysInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reference_Field_Net_DaysInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_reference_field_net_days(inputs)
});